<script setup lang="ts">
import type { HybridlyFormData } from '@/@types/global';
import type { AppliedFilters } from '@/components/distiller/types';

import FormProgramInput from '@/components/formComboboxInput/FormProgramInput.vue';
import FormMultiUserInput from '@/components/formComboboxInput/FormMultiUserInput.vue';
import FormDateInput from '@/components/formDateInput/FormDateInput.vue';
import Alert from '@/components/alert/Alert.vue';
import { watch } from 'vue';

import ExclamationTriangle from '@/icons/line/exclamation-triangle.svg';

const props = defineProps<{
  form: HybridlyFormData<{ filters: AppliedFilters }>;
}>();

watch(
  () => props.form.fields.filters.program_id,
  () => {
    props.form.fields.filters.user_ids = [];
  }
);
</script>

<template>
  <FormProgramInput
    label="Program"
    name="program_id"
    :modelValue="form.fields.filters.program_id as any"
    @update:modelValue="(value) => (form.fields.filters.program_id = value as any)"
  />
  <FormMultiUserInput
    label="Adviser"
    name="user_ids"
    :modelValue="form.fields.filters.user_ids as any"
    :searchFilters="{ role: 'adviser' }"
    :selectAll="true"
    :programIds="
      form.fields.filters.program_id ? [form.fields.filters.program_id.value as number] : []
    "
    @update:modelValue="(value) => (form.fields.filters.user_ids = value as any)"
  />
  <FormDateInput
    label="Start Date"
    name="start_date"
    :modelValue="form.fields.filters.start_date as any"
    @update:modelValue="(value) => (form.fields.filters.start_date = value as any)"
  />
  <FormDateInput
    label="End Date"
    name="end_date"
    :modelValue="form.fields.filters.end_date as any"
    @update:modelValue="(value) => (form.fields.filters.end_date = value as any)"
  />
  <Alert
    v-if="form.errors.filters"
    :icon="ExclamationTriangle"
    :description="formatErrors(form.errors.filters)"
    title="Filter errors"
    color="danger"
    variant="soft"
  />
</template>
